import { render, staticRenderFns } from "./DriverCreate.vue?vue&type=template&id=1c314ef8"
import script from "./DriverCreate.vue?vue&type=script&lang=js"
export * from "./DriverCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports